export default __webpack_public_path__ + "static/media/pay.fddea862.jpg";